export default __webpack_public_path__ + "ffc345d2d1667539b5f8a37f42467bde.svg";